// src/redux/modules/auth/services/baseApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '@/rtkQuery/lib';

export const baseApi = createApi({
    reducerPath: 'baseApi',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['Auth', 'Questionnaires', 'Cart', 'Testimonials', 'OrderHistory', 'ProductList', 'PatientInfo', 'Payment', 'SavedCard', 'ShippingPolicy', 'RecentOrders', 'WatchedVideos','CheckoutReview'],
    endpoints: () => ({}),
});